import { resendEmailVerification } from "@/api/nextme/registration"
import { Box, Modal } from "@mui/material"
import { useDispatch } from "react-redux"
import { useState } from "react"
import { setAlert } from "@/store/slices/alertSlice"
import { AlertMessageEnum, AlertTypeEnum } from "@/consts/alert-messages"
import styles from "@/styles/Modal.module.css"
import WaitlistEntryModalTitle from "../waitlist/WaitlistEntryModal/WaitlistEntryModalTitle"
import buttonStyles from "@/styles/Buttons.module.scss"
import classNames from "classnames"
import Link from "next/link"

interface Props {
  open: boolean
  email: string
}

export default function EmailVerifyModal({ open, email }: Props) {
  const dispatch = useDispatch()

  const [isResending, setIsResending] = useState(false)

  const handleResendEmailRqst = async () => {
    setIsResending(true)

    await resendEmailVerification()
      .then(() => {})
      .catch((err) => {
        if (err.response?.status === 500) {
          dispatch(
            setAlert({
              isOpen: true,
              message: AlertMessageEnum.errors.generic.text,
              title: AlertMessageEnum.errors.generic.title,
              type: AlertTypeEnum.error,
            })
          )
        }
      })

    setIsResending(false)
  }

  return (
    <Modal open={open}>
      <Box className={styles.modalBox}>
        <WaitlistEntryModalTitle
          icon={"/icons/mail.svg"}
          title={"Verify Your Email"}
        />
        <p>
          Almost there! Please click the confirmation link sent to
          &nbsp;<strong>{email}</strong> to continue creating your account.
        </p>
        <br />
        <Box className={styles.modalButtonRow}>
          <button type="button" className={classNames(buttonStyles.grayBtn)}>
            <Link href="/logout">
              <a className={styles.modalLink}>Close</a>
            </Link>
          </button>
          <button
            type="button"
            className={classNames(buttonStyles.blueBtn)}
            style={{ border: "none" }}
            onClick={() => !isResending && handleResendEmailRqst()}
            disabled={isResending}
          >
            {isResending ? "Sending email..." : "Send Again"}
          </button>
        </Box>
      </Box>
    </Modal>
  )
}
